import { useState, useEffect } from "react";
import customFetch from "../../../API/CustomFetch";
import showToastMessage from "../../../Toastify/Index";
import TermsAndConditionsModal from "../../customer-consent/components/TermsAndConditionsModal";
import { customer_consent_verify_otp } from "../../../API/api";

type Props = {
  typeMasterId: string;
  vehicleProfileId: string;
  customerVerifiedOTP?: number | null;
};

const CustomerConsentOtp = ({
  typeMasterId,
  vehicleProfileId,
  customerVerifiedOTP,
}: Props) => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [oTPVerified, SetOTPVerified] = useState(false);

  /* ---------------- API ---------------- */
  const handleVerifyOtp = async () => {
    try {
      setLoading(true);

      const url = `${customer_consent_verify_otp}/${typeMasterId}/${vehicleProfileId}/${otp}`;

      //   const url = `api/customer-consent/v1/verify-otp/${typeMasterId}/${vehicleProfileId}/${otp}`;

      const res = await customFetch(url, "", { method: "POST" });

      if (res?.SUCCESS) {
        showToastMessage(true, res?.MESSAGE || "Consent verified successfully");
        SetOTPVerified(true);
      } else {
        showToastMessage(false, res?.MESSAGE);
        SetOTPVerified(false);
      }
    } catch {
      showToastMessage(false, "Error verifying OTP");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- Disable Background Scroll (Modal) ---------------- */
  useEffect(() => {
    if (isTermsOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isTermsOpen]);

  return (
    <>
      {oTPVerified || customerVerifiedOTP === 1 ? (
        /* ✅ PRINT BUTTON */
        <div className="text-center">
          <button
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded"
            onClick={() => window.print()}
          >
            Print
          </button>
        </div>
      ) : (
        /* ✅ OTP CARD */
        <div className="bg-white border rounded-lg px-4 py-6 md:px-32 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          {/* LEFT */}
          <div className="space-y-4 w-full max-w-sm">
            {/* Checkbox */}
            <div className="flex items-start gap-2">
              <input
                type="checkbox"
                checked={isAccepted}
                readOnly
                className="w-4 h-4 mt-0.5 shrink-0"
              />

              <span className="text-sm break-words">
                I agree with the{" "}
                <span
                  className="text-blue-600 cursor-pointer underline"
                  onClick={() => setIsTermsOpen(true)}
                >
                  Terms & Conditions
                </span>
              </span>
            </div>

            {/* OTP Input */}
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              disabled={!isAccepted}
              className={`w-full border rounded-md p-2 text-sm ${
                !isAccepted ? "bg-gray-100 cursor-not-allowed" : ""
              }`}
            />
            {!isAccepted && (
              <p className="text-red-500 text-sm italic mt-2">
                Please accept Terms & Conditions before entering OTP
              </p>
            )}

            {/* Button */}
            <button
              onClick={handleVerifyOtp}
              disabled={!isAccepted || !otp || loading}
              className={`w-full py-2 rounded-md text-white ${
                !isAccepted || !otp
                  ? "bg-green-300 cursor-not-allowed"
                  : "bg-green-600 hover:bg-green-700"
              }`}
            >
              {loading ? "Verifying..." : "Verify OTP to Agree"}
            </button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="hidden md:block">
            <img src="icon/otp-image.png" alt="OPT" className="w-64 h-full" />
          </div>
        </div>
      )}

      {/* TERMS MODAL */}
      <TermsAndConditionsModal
        isOpen={isTermsOpen}
        isAccepted={isAccepted}
        onAccept={() => {
          setIsAccepted(true);
          setIsTermsOpen(false);
        }}
        onReject={() => {
          setIsAccepted(false);
          setIsTermsOpen(false);
        }}
      />
    </>
  );
};

export default CustomerConsentOtp;

// http://localhost:3000/api/customer-consent/v1/verify-otp/53/438/1233
// https://rvrlevym6i.execute-api.ap-south-1.amazonaws.com/dev/api/customer-consent/v1/verify-otp/53/112/12331
